var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 0H3.76C1 0 0 1 0 3.81V16.19C0 19 1 20 3.76 20H12.23C15 20 16 19 16 16.19V3.81C16 1 15 0 12.24 0ZM8 17.3C7.04 17.3 6.25 16.51 6.25 15.55C6.25 14.59 7.04 13.8 8 13.8C8.96 13.8 9.75 14.59 9.75 15.55C9.75 16.51 8.96 17.3 8 17.3ZM10 4.25H6C5.59 4.25 5.25 3.91 5.25 3.5C5.25 3.09 5.59 2.75 6 2.75H10C10.41 2.75 10.75 3.09 10.75 3.5C10.75 3.91 10.41 4.25 10 4.25Z",
    fill: "#45436B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.24d8da81d7f826d25e872d8c2063bf0e.svg";
export { ForwardRef as ReactComponent };